import _map from 'lodash/map';
import { buildBaseEventData, buildErrorAnalyticsEvent } from './commonAnalytics';
import { Analytics } from './sendAnalyticsEvent';
import { groupBy } from './analyticsFunctions';

export const trackClickEvent = (eventName, { omsId, productName, brand }, eventType = 'stash', pageType) => {
  const clickEvent = buildBaseEventData(eventType, eventName);
  clickEvent.eventMode = 'stash';
  let item = [{
    index: '',
    omsId,
  }];
  if (omsId) {
    item = [{
      productInfo: {
        sku: `${omsId}`,
        productName,
        manufacturer: `${brand}`,
        productType: 'merchandise',
      },
    }];
  }
  clickEvent.stash = {
    pageType,
    sharedSection: '',
    section: '',
    component: '',
    target: 'atc',
    item,
  };

  Analytics.sendAnalyticsEvent(clickEvent);
};

export const trackClick = (eventName, { omsId, productName, brand }, eventType) => {
  trackClickEvent(eventName, { omsId, productName, brand }, eventType);
};

export const addItemToStack = (trackAddItemToStack) => {
  const {
    items,
    primaryCategory,
    eventName
  } = trackAddItemToStack;

  const item = _map(items);

  const addItemToStackEvent = {
    category: { primaryCategory },
    eventInfo: { eventName },
    item
  };

  Analytics.sendAnalyticsEvent(addItemToStackEvent);
};

export const removeItemsFromStack = (trackRemoveItemsFromStack) => {

  const { target, productArray } = trackRemoveItemsFromStack;

  const targetClickEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'pip sub-content' },
    subContent: { component: 'remove-item', section: 'stack-builder', target },
  };

  Analytics.sendAnalyticsEvent(targetClickEvent);

  const groupedBySku = groupBy(productArray, (product) => product.sku);

  const item = Object.keys(groupedBySku).map((sku) => {
    const quantity = groupedBySku[sku][0].quantity || groupedBySku[sku].length;
    const basePrice = groupedBySku[sku][0].basePrice;
    return ({
      quantity,
      price: { basePrice },
      productInfo: { sku },
    });
  });

  const removeItemsFromStackEvent = {
    category: { primaryCategory: 'button submission' },
    eventInfo: { eventName: 'bundle remove' },
    item
  };

  Analytics.sendAnalyticsEvent(removeItemsFromStackEvent);
};

export const modalLinkClick = (trackModalLinkClick) => {
  const { feature, stackDimensions, name } = trackModalLinkClick;
  const { height, width, depth } = stackDimensions;

  const module = [];
  module.push({
    name,
    feature,
    type: `${height?.toFixed(2)}h${width?.toFixed(2)}w${depth?.toFixed(2)}d`
  });

  const modalLinkClickEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'configurator click' },
    content: { module },
  };

  Analytics.sendAnalyticsEvent(modalLinkClickEvent);

  const modalShownEvent = {
    category: { primaryCategory: 'overlay' },
    eventInfo: { eventName: 'stack summary' },
  };

  Analytics.sendAnalyticsEvent(modalShownEvent);
};

export const calloutModalLinkClick = (trackModalLinkClick) => {
  const { callout } = trackModalLinkClick;
  const { eventName } = callout;

  const modalShownEvent = {
    category: { primaryCategory: 'overlay' },
    eventInfo: { eventName },
  };

  Analytics.sendAnalyticsEvent(modalShownEvent);
};

export const calloutModalClose = (trackModalClose) => {
  const { feature, callout } = trackModalClose;
  const { name, type, eventName } = callout;
  const module = [];
  module.push({
    name: name.toLowerCase(),
    feature: eventName.toLowerCase(),
    type: type.toLowerCase()
  });

  const calloutModalCloseEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'pip sub-content' },
    content: { module },
    subContent: { component: 'button', section: eventName.toLowerCase(), target: feature.toLowerCase() },
  };

  Analytics.sendAnalyticsEvent(calloutModalCloseEvent);
};

export const zoomModalClick = () => {
  const zoomModalClickEvent = {
    category: { primaryCategory: 'overlay' },
    eventInfo: { eventName: 'stack builder zoom' },
  };

  Analytics.sendAnalyticsEvent(zoomModalClickEvent);
};

export const printStackSummary = () => {
  const printStackSummaryEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'pip sub-content' },
    subContent: { component: 'system', section: 'sharing', target: 'print' },
  };

  Analytics.sendAnalyticsEvent(printStackSummaryEvent);
};

export const quickViewModalLoad = () => {
  const quickViewModalLoadEvent = {
    category: { primaryCategory: 'overlay' },
    eventInfo: { eventName: 'pip quick view' },
  };

  Analytics.sendAnalyticsEvent(quickViewModalLoadEvent);
};

export const continueBuilding = () => {
  const continueBuildingEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'pip sub-content' },
    subContent: { component: 'button', section: 'stack summary', target: 'continue building' },
  };

  Analytics.sendAnalyticsEvent(continueBuildingEvent);
};

export const shareDesign = (trackShareDesignEvent) => {
  const { target, currentUrl } = trackShareDesignEvent;
  const shareDesignEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'pip sub-content' },
    subContent: { component: 'socialmedia', section: 'sharing', target, shareUrl: currentUrl },
  };

  Analytics.sendAnalyticsEvent(shareDesignEvent);
};

export const quickViewSectionViewed = (trackQuickViewSectionViewedEvent) => {
  const { title: target } = trackQuickViewSectionViewedEvent;
  const quickViewSectionViewedEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'pip sub-content' },
    subContent: { component: 'fly out', section: 'pip quick view', target },
  };

  Analytics.sendAnalyticsEvent(quickViewSectionViewedEvent);
};

export const quickViewPipClickThrough = (trackQuickViewPipClickThroughEvent) => {
  const { productType } = trackQuickViewPipClickThroughEvent;
  const details = productType ? `view full details|${productType}` : 'view full details';
  const quickViewPipClickThroughEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'pip sub-content' },
    subContent: { component: 'button', section: 'pip quick view', target: details },
  };
  Analytics.sendAnalyticsEvent(quickViewPipClickThroughEvent);
};

export const errorInteractions = (trackErrorInteractionsEvent) => {
  const { errorObject, primaryCategory, eventName } = trackErrorInteractionsEvent;
  const errorEvent = buildErrorAnalyticsEvent(errorObject, primaryCategory, eventName);
  Analytics.sendAnalyticsEvent(errorEvent);
};

export const promotionAccordions = (trackPromotionAccordionsEvent) => {
  const { target } = trackPromotionAccordionsEvent;
  const promotionAccordionsEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'pip sub-content' },
    subContent: { component: 'accordion', section: 'stack summary promotions', target },
  };
  Analytics.sendAnalyticsEvent(promotionAccordionsEvent);
};

export const changeCollection = () => {
  const changeCollectionEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'pip sub-content' },
    subContent: { component: 'button', section: 'your cabinet project', target: 'change cabinet collection' },
  };

  Analytics.sendAnalyticsEvent(changeCollectionEvent);
};

export const preconfigureLayoutLinkClick = (event) => {
  const { templateName } = event;
  const shareDesignEvent = {
    category: { primaryCategory: 'interaction' },
    eventInfo: { eventName: 'pip sub-content' },
    subContent: { component: 'preconfigured layout', section: 'cabinet wall', target: `${templateName} layout` },
  };

  Analytics.sendAnalyticsEvent(shareDesignEvent);
};

export const preconfiguredConfirmationModalClick = () => {
  const preconfiguredConfirmationModalEvent = {
    category: { primaryCategory: 'overlay' },
    eventInfo: { eventName: 'cabinet configurator - restart wall preconfigured' }
  };

  Analytics.sendAnalyticsEvent(preconfiguredConfirmationModalEvent);
};
